module.exports = __webpack_public_path__ + "static/SiteNoob-1de4f76ddbdd81441329c9659f946652.png";